import React, { Component } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Radium from "radium";
import { connect } from "react-redux";
import { routeActions } from "redux-simple-router";
import Waves from "node-waves";
import {
  attemptGetWorkplaces,
  onWorkplaceDrop,
  getProjectSuggestions,
  setColumnsShowing,
  setShowOwnWorkplaces,
  setProjectSuggestionValue,
  attemptGetMissingWorkplaces,
} from "./actions";
import {
  setIsStartOfWeek,
  setEmployeeWeekoverviewDate,
} from "../EmployeeWeekOverview/actions";
import Column from "./column";
import Sidebar from "./Sidebar";
import { departmentColumns, showSidebarConst } from "../../Globals/constants";
import { greyScaleColors, semanticColors } from "../../Globals/styles";
import NewSuggestSelectInput from "../../Common/newSuggestSelectInput";
import GatheredColumns from "./gatheredColumns";
import StickyNoteDroppable from "./stickyNoteDroppable";
import DepartmentDailyreports from "./DepartmentDailyreports/index";
import DepartmentFeed from "./DepartmentFeed/index";
import { setDate } from "../Workplace/DailyReport/actions";

import "../../../Content/css/sidebarSlideAnimation.css";
import auth from "../../Login/authService";
import { setNavHeader } from "../../MainClient/Navbar/actions";

var PAGINATION_COUNT_PER_PAGE = 10;

class Kanban extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSidebar: showSidebarConst.NOT_SHOWING,
      pageForInvoice: 1,
      display: false,
      popped: false,
    };
  }
  componentWillMount = () => {
    this.props.dispatch(setNavHeader(true, ""));

    if (this.props.showSidebar) {
      this.setState({
        showSidebar: this.props.showSidebar,
      });
    }

    if (this.props.departmentId != this.props.params.departmentId) {
      this.props.dispatch(
        attemptGetWorkplaces(this.props.params.departmentId, true)
      );
    } else if (this.props.updatedAt) {
      // var secondsPast = (new Date().getTime() - this.props.updatedAt) / 1000;
      // if (secondsPast > 600)
      this.props.dispatch(
        attemptGetWorkplaces(this.props.params.departmentId, false)
      );
    }
  };
  componentDidMount = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  getMoreInvoiced = () => {
    const { organizer } = this.props;

    let missingWorkplaces = organizer[organizer.length - 1].items.slice(
      this.state.pageForInvoice * PAGINATION_COUNT_PER_PAGE,
      (this.state.pageForInvoice + 1) * PAGINATION_COUNT_PER_PAGE
    );
    if (missingWorkplaces.length) {
      this.props.dispatch(attemptGetMissingWorkplaces(missingWorkplaces));
      this.setState({
        pageForInvoice: this.state.pageForInvoice + 1,
      });
    }
  };
  toggleShowSidebar = (val) => {
    //if hide the sidebar, reset the state of the sidebar
    if (val === showSidebarConst.NOT_SHOWING) {
      this.props.dispatch(setIsStartOfWeek(true));
      this.props.dispatch(setEmployeeWeekoverviewDate(new Date()));
    }

    this.setState({
      showSidebar: val,
    });
  };
  onProjectSuggestChange = (projectSuggestionValue) => {
    if (projectSuggestionValue.id)
      this.props.dispatch(setProjectSuggestionValue(projectSuggestionValue));
    else if (
      this.props.projectSuggestionValue.id &&
      !projectSuggestionValue.id
    ) {
      this.props.dispatch(setProjectSuggestionValue(projectSuggestionValue));
    }
  };

  toggleShowOwnWorkplaces = (showOwnWorkplaces) => {
    this.props.dispatch(setShowOwnWorkplaces(showOwnWorkplaces));
  };

  goToDailyReport = (date, id, workplaceId) => {
    const { params, dispatch } = this.props;
    dispatch(setDate(date, id));
    dispatch(
      routeActions.push(
        "/afdeling/" +
          params.departmentId +
          "/arbejdssted/" +
          workplaceId +
          "/dagrapport"
      )
    );
  };

  goToWorkplace = (workplaceId) => {
    const { params, dispatch } = this.props;
    dispatch(
      routeActions.push(
        "/afdeling/" +
          params.departmentId +
          "/arbejdssted/" +
          workplaceId +
          "/oversigt"
      )
    );
  };

  gotoAPV = (workplaceId) => {
    const { params, dispatch } = this.props;
    dispatch(
      routeActions.push(
        "/afdeling/" +
          params.departmentId +
          "/arbejdssted/" +
          workplaceId +
          "/arbejdsmiljo"
      )
    );
  };

  render() {
    const {
      params,
      dispatch,
      organizer,
      draggingWorkplace,
      projectSuggestions,
      workplaces,
      departmentName,
      columnsShowing,
      showOwnWorkplaces,
      projectSuggestionValue,
    } = this.props;
    const user = auth.getProfile();
    const { showSidebar } = this.state;
    let columnNodes = [];
    organizer.forEach((singleOrganizer, index) => {
      if (index >= columnsShowing.from && index <= columnsShowing.to) {
        columnNodes.push(
          <div key={index} className="col-sm-3" style={styles.column}>
            {index === 0 ? (
              <div style={styles.createWorkplaceButtonContainer}>
                <button
                  className="btn btn-primary waves-btn"
                  onClick={() =>
                    dispatch(
                      routeActions.push(
                        "/afdeling/" +
                          params.departmentId +
                          "/arbejdssted/opret/oversigt"
                      )
                    )
                  }
                  style={[styles.createWorkplaceButton]}
                >
                  Opret arbejdssted...
                </button>
              </div>
            ) : null}
            {/* pagination on invoiced column rm'ed. replace the following to bring back the pagination*/}
            {/* !! The pagination is dependent on the backend !!*/}
            {/* workplaceIds={index===organizer.length -1 ? singleOrganizer.items.slice(0, this.state.pageForInvoice*PAGINATION_COUNT_PER_PAGE) : singleOrganizer.items} */}
            {/* hasPagination={index===organizer.length -1} */}
            {/* V   V   V   V   V   V   V   V   V   V */}
            <Column
              columnIndex={index}
              title={departmentColumns[index]}
              workplaceIds={singleOrganizer.items}
              params={params}
              draggingWorkplace={draggingWorkplace}
              showSidebar={showSidebar}
              sortByProject={projectSuggestionValue.id}
              sortByUser={
                showOwnWorkplaces ? user["https://ceas/username"].toUpperCase() : null
              }
              matches={this.props.matches}
              workplaces={workplaces}
              nextPage={this.getMoreInvoiced}
              workplaceIds={
                index === organizer.length - 1
                  ? singleOrganizer.items.slice(
                      0,
                      this.state.pageForInvoice * PAGINATION_COUNT_PER_PAGE
                    )
                  : singleOrganizer.items
              }
              hasPagination={index === organizer.length - 1}
              onWorkplaceDrop={(
                workplaceId,
                columnId,
                index,
                oldColumnId,
                oldIndex
              ) =>
                dispatch(
                  onWorkplaceDrop(
                    workplaceId,
                    columnId,
                    index,
                    oldColumnId,
                    oldIndex
                  )
                )
              }
            />
          </div>
        );
      }
    });
    const isMas = process.env.REACT_APP_title.includes("Mas");
    return (
      <div
        style={[
          styles.container,
          showSidebar === showSidebarConst.EMP_WEEK_OVERVIEW &&
            styles.openedWeekOverview,
        ]}
      >
        <div style={styles.navContainerHeading}>
          <div style={styles.departmentName}>{departmentName}</div>
        </div>
        <div style={styles.navContainer}>
          <div
            className="waves-btn"
            style={[
              styles.navItem,
              columnsShowing.from === 0 && styles.navItemActive,
            ]}
            onClick={() => dispatch(setColumnsShowing(0, 3))}
          >
            PLANLÆGNING
          </div>
          <span style={styles.navDivider}>|</span>
          <div
            className="waves-btn"
            style={[
              styles.navItem,
              columnsShowing.from === 3 && styles.navItemActive,
            ]}
            onClick={() => dispatch(setColumnsShowing(3, 6))}
          >
            PRODUKTION
          </div>
          {user.role === "Formand" ? null : (
            <div style={{ display: "inline-block" }}>
              <span style={styles.navDivider}>|</span>
              <div
                className="waves-btn"
                style={[
                  styles.navItem,
                  columnsShowing.from === 6 && styles.navItemActive,
                ]}
                onClick={() => dispatch(setColumnsShowing(6, 9))}
              >
                FAKTURERING
              </div>
            </div>
          )}
        </div>
        {showSidebar !== showSidebarConst.EMP_WEEK_OVERVIEW ? (
          <div className="row" style={styles.upperContainer}>
            <div
              className="col-xs-3"
              style={{
                minWidth: 224,
              }}
            >
              <div className="col-xs-6 col-lg-5" style={styles.Vis}>
                <div
                  className={
                    !showOwnWorkplaces && !projectSuggestionValue.id
                      ? "btn btn-info waves-btn"
                      : "btn btn-default waves-btn"
                  }
                  style={[
                    styles.seeAll,
                    !projectSuggestionValue.id ? null : styles.borderRight,
                  ]}
                  onClick={() => this.toggleShowOwnWorkplaces(false)}
                >
                  Alle
                </div>
                <div
                  className={
                    showOwnWorkplaces && !projectSuggestionValue.id
                      ? "btn btn-info waves-btn"
                      : "btn btn-default waves-btn"
                  }
                  style={styles.seeFavorite}
                  onClick={() => this.toggleShowOwnWorkplaces(true)}
                >
                  Mine
                </div>
              </div>
              <div className="col-xs-6 col-lg-7" style={styles.paddingLeft}>
                <NewSuggestSelectInput
                  onClick={() => {
                    const { organizer } = this.props;

                    let missingWorkplaces = organizer[
                      organizer.length - 1
                    ].items.slice(
                      this.state.pageForInvoice * PAGINATION_COUNT_PER_PAGE
                    );
                    if (missingWorkplaces.length) {
                      this.props.dispatch(
                        attemptGetMissingWorkplaces(missingWorkplaces)
                      );
                      this.setState({
                        pageForInvoice: missingWorkplaces.length,
                      });
                    }
                  }}
                  onQuery={(val) => dispatch(getProjectSuggestions(val))}
                  suggestions={projectSuggestions}
                  placeholder="Søg"
                  onChange={this.onProjectSuggestChange}
                  value={projectSuggestionValue}
                  inputStyle={[
                    styles.suggestSelectInput,
                    projectSuggestionValue.id &&
                      styles.suggestSelectInputActive,
                  ]}
                  listgroupStyle={styles.listGroup}
                >
                  <i
                    className="fa fa-search"
                    style={[
                      styles.suggestSelectInputIcon,
                      projectSuggestionValue.id &&
                        styles.suggestSelectInputActive,
                    ]}
                    aria-hidden="true"
                  ></i>
                </NewSuggestSelectInput>
              </div>
            </div>

            <div
              className="col-xs-3 pull-right"
              style={{
                minWidth: 251,
                "@media (min-width: 320px) and (max-width: 480px)": {
                  float: "left",
                  top: "8px",
                },
              }}
            >
              <button
                className="btn btn-primary waves-btn"
                onClick={() => {
                  this.setState({
                    popped: false,
                  });
                  this.toggleShowSidebar(showSidebarConst.EMP_WEEK_OVERVIEW);
                }}
                style={[styles.timeRegistrationBtn]}
              >
                Overblik
              </button>
              <button
                className="btn btn-primary waves-btn"
                onClick={() => {
                  this.setState({
                    popped: false,
                  });
                  this.toggleShowSidebar(showSidebarConst.EMP_LIST);
                }}
                style={[styles.timeRegistrationBtn, styles.floatLeft]}
              >
                Tildeling
              </button>
            </div>

            <div
              className="col-xs-3 pull-right"
              style={{
                minWidth: 251,
                "@media (min-width: 320px) and (max-width: 480px)": {
                  float: "left",
                  top: "8px",
                },
              }}
            >
              <button
                className="btn btn-primary waves-btn"
                onClick={() => {
                  const url = isMas
                    ? "planner.mas.dagrapport.dk"
                    : "planner.ceas.io";
                  window.open(
                    `https://${url}?departmentId=${
                      this.props.params.departmentId
                    }&token=${auth.getToken()}`,
                    "_blank"
                  );
                }}
                style={[styles.timeRegistrationBtn]}
              >
                Planlæg
              </button>
              <div
                style={{
                  fontWeight: 600,
                  color: "white",
                  paddingTop: 9,
                  textAlign: "right",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  let newPoppedState = !this.state.popped;
                  if (newPoppedState === false) {
                    setTimeout(() => {
                      this.setState({
                        display: newPoppedState,
                      });
                    }, 900);
                    this.setState({
                      popped: newPoppedState,
                    });
                  } else {
                    this.setState({
                      popped: newPoppedState,
                      display: true,
                    });
                  }

                  this.toggleShowSidebar(showSidebarConst.NOT_SHOWING);
                }}
              >
                VIS {this.state.popped ? "MINDRE" : "MERE"}
                {!this.state.popped ? (
                  <i
                    className="fa fa-caret-square-o-down"
                    style={{ paddingLeft: 5 }}
                    aria-hidden="true"
                  ></i>
                ) : (
                  <i
                    className="fa fa-caret-square-o-up"
                    style={{ paddingLeft: 5 }}
                    aria-hidden="true"
                  ></i>
                )}
              </div>
            </div>
          </div>
        ) : null}
        <div style={{ height: 1 }}></div>
        <div
          className="accordion-content"
          style={
            this.state.popped
              ? {
                  maxHeight: "650px",
                }
              : { maxHeight: 0 }
          }
        >
          <div
            style={{
              width: "100%",
              height: "600px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                minWidth: 485,
                display: "inline-block",
              }}
              className="col-xs-4"
            >
              {this.state.display ? (
                <DepartmentDailyreports
                  departmentId={this.props.params.departmentId}
                  workplaces={workplaces}
                  userCanEdit={auth.getProfile().role !== "Formand"}
                  goToDailyReport={this.goToDailyReport}
                />
              ) : null}
            </div>
            <div
              style={{
                width: 485,
                display: "inline-block",
                float: "right",
                marginRight: 14,
              }}
              className="col-xs-4"
            >
              {this.state.display ? (
                <DepartmentFeed
                  departmentId={this.props.params.departmentId}
                  workplaces={workplaces}
                  goToDailyReport={this.goToDailyReport}
                  gotoWorkplace={this.goToWorkplace}
                  gotoAPV={this.gotoAPV}
                />
              ) : null}
            </div>
          </div>
        </div>

        <div className="row" style={styles.columnContainer}>
          {showSidebar === showSidebarConst.EMP_WEEK_OVERVIEW ? (
            <div className="col-sm-3" style={[styles.column]}>
              <StickyNoteDroppable />
              <GatheredColumns
                organizer={organizer}
                showSidebar={showSidebar}
                workplaces={workplaces}
                sortByUser={
                  showOwnWorkplaces ? user["https://ceas/username"].toUpperCase() : null
                }
                columnsShowing={columnsShowing}
                paginationCountPerPage={PAGINATION_COUNT_PER_PAGE}
                pageForInvoice={this.state.pageForInvoice}
              />
            </div>
          ) : (
            columnNodes
          )}
        </div>
        <ReactCSSTransitionGroup
          transitionName="slide"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {showSidebar !== showSidebarConst.NOT_SHOWING ? (
            <Sidebar
              toggleSidebar={this.toggleShowSidebar}
              showSidebar={this.state.showSidebar}
              params={params}
            />
          ) : null}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

var styles = {
  timeRegistrationBtn: {
    borderRadius: "2px",
    padding: "0px",
    width: "113px",
    float: "right",
    textAlign: "center",
    zIndex: "0",
    "@media (min-width: 1200px)": {
      width: "130px",
    },
  },
  container: {
    position: "absolute",
    top: "0",
    left: "0",
    padding: "100px 12px 0 12px",
    width: "100%",
    height: "99%",
    marginRight: "auto",
    marginLeft: "auto",
    "@media (min-width: 1200px)": {
      maxWidth: "1170px",
      left: "50%",
      marginLeft: "-585px",
    },
  },
  openedWeekOverview: {
    padding: "51px 12px 0 12px",
  },
  upperContainer: {
    position: "absolute",
    top: "58px",
    width: "100%",
    "@media (min-width: 320px) and (max-width: 480px)": {
      top: "110px",
    },
  },
  columnContainer: {
    position: "relative",
    padding: "0 0 12px 0",
    height: "100%",
    "@media (min-width: 320px) and (max-width: 480px)": {
      top: "120px",
    },
  },
  createWorkplaceButton: {
    width: "100%",
    borderRadius: "0 0 2px 2px",
    textAlign: "left",
    fontSize: "12px",
  },
  createWorkplaceButtonContainer: {
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    padding: "0 12px",
  },
  navContainerHeading: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    textAlign: "center",
    lineHeight: "50px",
  },
  navContainer: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    textAlign: "center",
    lineHeight: "50px",
    "@media (min-width: 320px) and (max-width: 480px)": {
      top: "50px",
      backgroundColor: semanticColors.default,
    },
  },
  departmentName: {
    position: "absolute",
    left: "60px",
    color: semanticColors.mainBackground,
  },
  navItem: {
    display: "inline-block",
    fontSize: "14px",
    cursor: "pointer",
    padding: "0 6px",
    height: "35px",
    lineHeight: "35px",
  },
  navItemActive: {
    color: semanticColors.info,
  },
  navDivider: {
    fontSize: "16px",
    width: "1px",
    color: semanticColors.mainBackground,
  },
  column: {
    height: "100%",
    position: "relative",
  },
  floatLeft: {
    float: "left",
  },
  searchInputContainer: {
    //width: '11%',
    //marginLeft : '-11%'
  },
  suggestSelectInput: {
    paddingLeft: "28px",
    height: "35px",
  },
  suggestSelectInputIcon: {
    position: "absolute",
    top: "10px",
    left: "10px",
    color: greyScaleColors.greyLight,
  },
  suggestSelectInputActive: {
    color: "#fff",
    backgroundColor: semanticColors.info,
  },
  seeAll: {
    width: "50px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "2px",
    borderBottomLeftRadius: "2px",
    borderBottomRightRadius: "0px",
  },
  seeFavorite: {
    width: "50px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    borderBottomLeftRadius: "0px",
  },
  listGroup: {
    width: "200px",
  },
  borderRight: {
    borderRight: "1px solid" + semanticColors.mainBackground,
  },
  Vis: {
    padding: "0px",
    height: "35px",
  },
  paddingLeft: {
    padding: "0px 0px 0px 3px",
  },
  mandskab: {
    textAlign: "right",
    float: "right",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
  },
};

const selectProps = (state) => {
  return {
    ...state.kanbanReducer,
  };
};

export default connect(selectProps)(Radium(Kanban));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/index.jsx